export const emptyStringValueToStringZero = (value: string | undefined): string => value || '0';
